import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'

import Loader from 'components/common/Loader'
import { _whiteboardUrl } from 'store/selectors/Whiteboard'

import * as Styles from './styles'
const IframeWhiteboard = () => {
    const [isLoading, setLoading] = useState(true)
    const iframeRef = useRef(null)
    const whiteboardUrl = useSelector(_whiteboardUrl)
    const handleIframeLoad = () => {
        if (iframeRef.current) {
            iframeRef.current.contentWindow.postMessage('CONTENT_LOADED', '*')
        }
        setLoading(false)
    }
    return (
        <>
            <Styles.Container>
                {isLoading && <Loader />}
                <Styles.StyledIframe
                    ref={iframeRef}
                    src={whiteboardUrl}
                    onLoad={handleIframeLoad}
                />
            </Styles.Container>
        </>
    )
}
export default IframeWhiteboard
